var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.method === "iframe"
      ? _c("iframe", {
          staticClass: "static-content-wrapper",
          style: { height: _vm.iframeHeight },
          attrs: {
            id: "iframe",
            src: _vm.url,
            scrolling: "no",
            frameborder: "0"
          },
          on: { load: _vm.iframeLoaded }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.method === "html" && _vm.html
      ? _c("div", {
          staticClass: "static-content-wrapper",
          domProps: { innerHTML: _vm._s(_vm.html) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ae03977", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ae03977","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/StaticContent.vue
// module id = null
// module chunks = 